import "./index.css";
import { useCallback, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useCookieContext } from "@/context/CookieContext";
import { ROUTES } from "@/router";
import { Button, Heading, Text } from "@/ui-kit";

export const Cookies = () => {
  const { t } = useTranslation();
  const context = useCookieContext();
  const navigate = useNavigate();
  const legalBasePath = useMemo(() => {
    const pathname = window.location.pathname;
    const match = pathname.match(/^\/([^/]+)\//);
    const publicPaths = [
      "auth",
      "legal",
      "logout",
      "register",
      "select-tenant",
    ];
    const tenant = match && !publicPaths.includes(match[1]) ? match[1] : null;
    return tenant ? `/${tenant}/${ROUTES.LEGAL}` : `/${ROUTES.LEGAL}`;
  }, []);

  const redirectToNotice = useCallback(() => {
    navigate(`${legalBasePath}/${ROUTES.COOKIE_NOTICE}`);
  }, [navigate, legalBasePath]);

  if (window.location.pathname.includes(ROUTES.SIGN_OUT)) {
    return null;
  }

  return (
    <div className="cookies">
      <Heading level={3} as="span">
        {t("legal.cookie_banner.title")}
      </Heading>
      <Text>
        <Trans i18nKey="legal.cookie_banner.text">
          We use cookies and similar technologies to improve functionality,
          analyze site usage, and provide personalized content. By clicking
          &#34;Accept All&#34;, you consent to our use of cookies. You can find
          out more about our use of cookies at our
          <a
            href={`${legalBasePath}/${ROUTES.COOKIE_NOTICE}`}
            target="_blank"
            className="cookies__link nuco-color-brand"
            rel="noreferrer"
          >
            Cookies Notice
          </a>
          , and about our data privacy measures at our
          <a
            href={`${legalBasePath}/${ROUTES.PRIVACY_POLICY}`}
            target="_blank"
            className="cookies__link nuco-color-brand"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          .
        </Trans>
      </Text>
      <footer className="cookies-actions">
        <Button
          variant="outline"
          content={t("legal.cookie_banner.manage_cookies")}
          onClick={redirectToNotice}
        />
        <Button
          variant="outline"
          content={t("legal.cookie_banner.reject_all")}
          onClick={context.onRejectAll}
        />
        <Button
          content={t("legal.cookie_banner.accept_all")}
          onClick={context.onAcceptAll}
        />
      </footer>
    </div>
  );
};
